<div class="header-container">
  <mat-toolbar color="primary">
    <mat-toolbar-row>
      <div class="header-logo">
        <a routerLink="/" aria-label="Go to home" class="header-logo-link">
          <img
            *ngIf="headerData.logoUrl"
            [src]="headerData.logoUrl"
            [alt]="headerData.logoAlt"
            class="logo"
          />
        </a>
      </div>

      <div class="menu-container">
        <nav class="primary-menu">
          <a
            *ngFor="let page of pageAssemblies"
            (click)="navigateToPage(page.slug, page.isProtected)"
            [routerLink]="page.slug"
            [routerLinkActiveOptions]="{ exact: page.slug === '' }"
            routerLinkActive="active-link"
          >
            <span class="menu-text" *ngIf="page.order > 0">
              {{ page.pageTitle }}
            </span>
          </a>
        </nav>
        <div class="secondary-menu">
          <button
            mat-button
            [matMenuTriggerFor]="menu"
            class="menu-button"
            [disableRipple]="true"
            (click)="toggleAccountMenu()"
          >
            <span>
              {{ menuText }}
            </span>
            <span>
              <mat-icon>{{
                isAccountMenuOpen ? 'expand_less' : 'expand_more'
              }}</mat-icon>
            </span>
          </button>
          <mat-menu #menu="matMenu" class="account-menu">
            <ng-container *ngIf="isLoggedIn; else guestMenu">
              <!-- <button mat-menu-item>Change Password</button> -->
              <button mat-menu-item (click)="onLogoutClick()">Logout</button>
            </ng-container>
            <ng-template #guestMenu>
              <button mat-menu-item (click)="onLoginClick()">Login</button>
              <!-- <button mat-menu-item (click)="onSignupClick()">
                Forgot Password
              </button> -->
            </ng-template>
          </mat-menu>
        </div>
      </div>
      <button
        mat-fab
        class="menu-icon"
        (click)="toggleMenu()"
        (keydown.enter)="toggleMenu()"
        (keydown.space)="toggleMenu()"
        [attr.aria-expanded]="isMenuOpen"
        aria-label="Toggle menu"
      >
        <mat-icon [class.rotate]="isMenuOpen">
          {{ isMenuOpen ? 'close' : 'menu' }}
        </mat-icon>
      </button>
    </mat-toolbar-row>
  </mat-toolbar>
  <div *ngIf="isMenuOpen" @slideToggle class="mobile-menu">
    <div *ngFor="let page of pageAssemblies">
      <a
        [routerLink]="page.slug"
        (click)="navigateToPage(page.slug, page.isProtected)"
        class="menu-item"
        *ngIf="page.order > 0"
      >
        {{ page.pageTitle }}
      </a>
    </div>
    <hr class="separator" />
    <a href="#" (click)="toggleAccountMenu($event)" class="menu-item-secondary">
      {{ menuText }}
      <mat-icon>{{
        isAccountMenuOpen ? 'expand_less' : 'expand_more'
      }}</mat-icon>
    </a>
    <div
      *ngIf="isAccountMenuOpen"
      class="secondary-mobile-menu"
      style="display: flex; flex-direction: column; align-items: flex-start"
    >
      <ng-container *ngIf="isLoggedIn; else guestMobileMenu">
        <!-- <a class="menu-item-secondary-sub" tabindex="0"> Change Password </a> -->
        <a
          class="menu-item-secondary-sub"
          (click)="onLogoutClick()"
          (keydown.enter)="onLogoutClick()"
          tabindex="0"
        >
          Logout
        </a>
      </ng-container>
      <ng-template #guestMobileMenu>
        <a
          class="menu-item-secondary-sub"
          (click)="onLoginClick()"
          (keydown.enter)="onLoginClick()"
          (keydown.space)="onLoginClick()"
          tabindex="0"
        >
          Login
        </a>
        <!-- <a
          class="menu-item-secondary-sub"
          (click)="onSignupClick()"
          (keydown.enter)="onSignupClick()"
          (keydown.space)="onSignupClick()"
          tabindex="0"
        >
          Forgot Password
        </a> -->
      </ng-template>
    </div>
  </div>
</div>
